<template>
  <div>
    <add-broker-component
      :broker-data-prop="brokerDataComputed"
      :is-edit="isEdit" 
      v-if="brokerDataComputed"/> 

  </div>
    
</template>

<script>
  import {mapActions, mapGetters} from "vuex";
  import AddBrokerComponent from "../../components/AddBrokerComponent";

  export default {
    name: "Edit",
    components: {AddBrokerComponent},
    data() {
      return {
        isEdit: true,
      }
    },
    async created() {
      this.$vs.loading({ text: 'Loading Broker Details' })
      if (this.brokers.length === 0) {
        await this.loadAllBrokers({
          storeName: 'brokers',
          url: `admin/brokers`,
          commitUrl: 'brokers/SET_BROKERS',
        })
      }
      await this.loadBrokerItemFun()
      this.$vs.loading.close()
    },
    computed: {
      ...mapGetters({
        brokers: 'brokers/brokersList',
        brokerData: 'brokers/editItem',
        isLoading: 'brokers/isLoading',
        error: 'brokers/error',
      }),
      listingDataComputed() {
        return this.listingData
      },
      brokerDataComputed() {
        return this.brokerData
      },
    },
    methods: {
      ...mapActions({
        loadAllBrokers: 'get',
        loadItem: 'getLocalItem',
      }),
      loadBrokerItemFun() {
        this.loadItem({
          commitUrl: 'brokers/GET_BROKER',
          id: this.$route.params.brokerID
        })
      }
    }
  }
</script>
